import { render, staticRenderFns } from "./ThePageFbChat.vue?vue&type=template&id=af9b2e04&scoped=true"
import script from "./ThePageFbChat.vue?vue&type=script&lang=js"
export * from "./ThePageFbChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9b2e04",
  null
  
)

export default component.exports